import type { Integration } from '../../../../api/endpoints/cloudApi.types';
import { IntegrationIssueType } from '../../../../api/endpoints/cloudApi.types';

// Determines which issue "wins" when an integration has more than one. Ranked so
// that whatever action we'd surface is actually worth taking: policyRestriction,
// adminApproval, and noAccessibleCalendar are all permanent account/org-level
// incompatibilities with no fix, so they outrank noConnect (don't prompt someone
// to pay for a subscription that can never work for their account). Within that,
// providerRevokedAccess ("renew access") is the narrowest fix, so it only shows
// when nothing else is wrong. Keep this in sync with any UI that branches on
// issue type.
const ISSUE_PRIORITY: IntegrationIssueType[] = [
  IntegrationIssueType.POLICY_RESTRICTION,
  IntegrationIssueType.ADMIN_APPROVAL,
  IntegrationIssueType.NO_ACCESSIBLE_CALENDAR,
  IntegrationIssueType.NO_CONNECT,
  IntegrationIssueType.PROVIDER_REVOKED_ACCESS,
];

export const getPrimaryIssue = (integration: Integration) => {
  const issues = integration.issues;
  if (!issues || issues.length === 0) return undefined;

  return issues.reduce<(typeof issues)[number] | undefined>(
    (primary, issue) => {
      if (!primary) return issue;

      const primaryRank = ISSUE_PRIORITY.indexOf(primary.type);
      const issueRank = ISSUE_PRIORITY.indexOf(issue.type);
      // Unrecognized types never outrank a recognized one, and never rank each other.
      if (issueRank === -1) return primary;
      if (primaryRank === -1) return issue;
      return issueRank < primaryRank ? issue : primary;
    },
    undefined
  );
};
